/* eslint jsx-a11y/anchor-is-valid: off,
no-script-url: off */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class AddonOption extends Component {
  handleClick = () => {
    this.props.onClick(this.props.num);
  }

  render() {
    return (
      <li>
        <a
          id={`${this.props.type}option`}
          href="javascript:void(0)"
          data-role={this.props.datarole}
          onClick={this.handleClick}
        >
          {this.props.children}
        </a>
      </li>
    );
  }
}

AddonOption.propTypes = {
  datarole: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  onClick: PropTypes.func.isRequired,
  num: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
};

export default AddonOption;



// WEBPACK FOOTER //
// ./src/components/AddonOption.jsx